/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled200,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled500,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledPathParams,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled500>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequestSchema =
  z.array(
    z.number().int(),
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationRequest>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationResponseSchema =
  z.lazy(
    () =>
      postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelled200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsOpenCancelledMutationResponse>;
